import { twMerge } from 'tailwind-merge';
function Button({ children, disabled = false, icon, mode = 'interactive', variant = 'solid', width = 'auto', size = 'default', classNames = {}, }) {
    const isClickable = mode === 'interactive';
    if (!children) {
        return null;
    }
    return children({
        className: twMerge(`inline-flex items-center justify-center gap-x-0.25 uppercase md:px-2 rounded-sm outline-none transition border select-none`, 
        // ensure all buttons meet minimum tap size
        `min-w-1.5 min-h-1.5`, 
        // ensure disabled buttons cannot trigger interaction states
        `disabled:pointer-events-none aria-disabled:pointer-events-none`, width === 'full' && `w-full`, width === 'auto' && [`w-auto`, variant !== 'text-only' && `max-sm:w-full`], size === 'default'
            ? 'px-1.5 type-button py-0.75'
            : 'px-0.5 py-0.5 md:py-0.75 truncate leading-tight type-button-sm md:type-button', isClickable
            ? [
                variant === 'solid' && [
                    `text-center bg-surface-cta border-surface-cta text-text-cta`,
                    `hover:bg-surface-brand-hover hover:border-surface-brand-hover hover:text-text-hover`,
                    `active:bg-surface-cta active:border-surface-cta active:text-text-invert`,
                    `focus-visible:outline-2 focus-visible:outline-border-accent focus-visible:outline-offset-0 focus-visible:outline-solid`,
                    `disabled:opacity-40 aria-disabled:opacity-40`,
                    classNames.solid,
                ],
                variant === 'outline' && [
                    `text-center bg-transparent border-border-standard text-text-body`,
                    `hover:bg-surface-brand-hover hover:border-surface-brand-hover hover:text-text-hover`,
                    `active:bg-transparent active:border-border-standard active:text-text-body`,
                    `focus-visible:outline-2 focus-visible:outline-border-standard focus-visible:outline-offset-0 focus-visible:outline-solid`,
                    `disabled:opacity-40 aria-disabled:opacity-40`,
                    classNames.outline,
                ],
                variant === 'text-only' && [
                    `-mt-0.25 text-left leading-8 bg-transparent text-text-body border-0 underline underline-offset-8 decoration-2 decoration-text-body !px-0 rounded-none pt-0 pb-0.25`,
                    `hover:bg-transparent hover:decoration-text-linkHover hover:text-text-linkHover`,
                    `active:bg-transparent active:border-text-body active:text-text-body`,
                    `focus-visible:outline-1 focus-visible:outline-text-body focus-visible:outline-offset-4 focus-visible:outline-dashed`,
                    `disabled:opacity-30 aria-disabled:opacity-30`,
                    classNames['text-only'],
                ],
                variant === 'frosted' && [
                    `text-center bg-surface-frosted/60 text-text-frostedOverlay backdrop-blur-[30px] border-0`,
                    `hover:bg-surface-brand-hover hover:text-text-hover`,
                    `active:bg-surface-frosted/60 active:text-text-frostedOverlay`,
                    `focus-visible:outline-2 focus-visible:outline-border-accent focus-visible:outline-offset-0 focus-visible:outline-solid`,
                    `disabled:opacity-40 aria-disabled:opacity-40`,
                    classNames.frosted,
                ],
            ]
            : [
                variant === 'solid' && [
                    `text-center bg-surface-cta border-surface-cta text-text-cta`,
                    `group-hover:bg-surface-brand-hover group-hover:border-surface-brand-hover group-hover:text-text-hover`,
                    `group-active:bg-surface-cta group-active:border-surface-cta group-active:text-text-invert`,
                    `group-focus-visible:outline-2 group-focus-visible:outline-border-accent group-focus-visible:outline-offset-0 group-focus-visible:outline-solid`,
                    classNames.solid,
                ],
                variant === 'outline' && [
                    `text-center bg-transparent border-border-standard text-text-body`,
                    `group-hover:bg-surface-brand-hover group-hover:border-surface-brand-hover group-hover:text-text-hover`,
                    `group-active:bg-transparent group-active:border-border-standard group-active:text-text-body`,
                    `group-focus-visible:outline-2 group-focus-visible:outline-border-standard group-focus-visible:outline-offset-0 group-focus-visible:outline-solid`,
                    classNames.outline,
                ],
                variant === 'text-only' && [
                    `-mt-0.25 text-left leading-8 bg-transparent text-text-body border-0 underline underline-offset-8 decoration-2 decoration-text-body !px-0 rounded-none pt-0 pb-0.25`,
                    `group-hover:bg-transparent group-hover:decoration-text-linkHover group-hover:text-text-linkHover`,
                    `group-active:bg-transparent group-active:border-text-body group-active:text-text-body`,
                    `group-focus-visible:outline-1 group-focus-visible:outline-text-body group-focus-visible:outline-offset-4 group-focus-visible:outline-dashed`,
                    classNames['text-only'],
                ],
                variant === 'frosted' && [
                    `text-center bg-surface-frosted/60 text-text-frostedOverlay backdrop-blur-[30px] border-0`,
                    `group-hover:bg-surface-brand-hover group-hover:text-text-hover`,
                    `group-active:bg-surface-frosted/60 group-active:text-text-frostedOverlay`,
                    `group-focus-visible:outline-2 group-focus-visible:outline-border-accent group-focus-visible:outline-offset-0 group-focus-visible:outline-solid`,
                    `group-disabled:opacity-40 group-aria-disabled:opacity-40`,
                    classNames.frosted,
                ],
            ]),
        disabled: isClickable ? disabled : undefined,
        icon,
    });
}
export default Button;
